import type { ListStepTypesResponse } from '@erp/rpc';

export type StepLibraryModule =
  ListStepTypesResponse['stepTypes'][number]['libraryModule'];

export function platformCategoryKey(category: string): string {
  return `platform::${category}`;
}

export function erpCategoryAccordionKey(
  module: string,
  category: string,
): string {
  return `erp::${module}::${category}`;
}
